const status = state => {
    return (state && state.status) || ''
}
const isLogin = state => {
    return state.isLogin || false
}
const loading = state => {
    return state.loading || 'loading'
}
const userInfo = state => {
    return state.userInfo || {}
}

const curGearInfo = state => {
    return state.curGearInfo || {}
}
const cgLoading = state => {
    return state.cgLoading || ''
}

const payModeInfo = state => {
    return state.payModeInfo || {}
}
const pmLoading = state => {
    return state.pmLoading || ''
}

const iapInfo = state => {
    return state.iapInfo || {}
}
const iapLoading = state => {
    return state.iapLoading || ''
}

const orderInfo = state => {
    return state.orderInfo || {}
}
const orderLoading = state => {
    return state.orderLoading || ''
}

const orderData = state => {
    return state.orderData || {}
}
const orderStatus = state => {
    return state.orderStatus || ''
}

const orderVerifyData = state => {
    return state.orderVerifyData || {}
}
const ovStatus = state => {
    return state.ovStatus || ''
}

const reqData = state => {
    return state.reqData || {}
}
const reqStatus = state => {
    return state.reqStatus || ''
}

const dpList = state => {
    return state.dpList || {}
}
const dpLoading = state => {
    return state.dpLoading || ''
}

const cRoleList = state => {
    return state.cRoleList || {}
}
const crLoading = state => {
    return state.crLoading || ''
}

const subList = state => {
    return state.subList || {}
}
const subLoading = state => {
    return state.subLoading || ''
}

const pointData = state => {
    return state.pointData || {}
}
const upLoading = state => {
    return state.upLoading || ''
}

const pointRule = state => {
    return state.pointRule || {}
}
const urLoading = state => {
    return state.urLoading || ''
}

const pointSwitch = state => {
    return state.pointSwitch || {}
}
const uwLoading = state => {
    return state.uwLoading || ''
}

const codeData = state => {
    return state.codeData || {}
}
const codeStatus = state => {
    return state.codeStatus || ''
}

const setEmailData = state => {
    return state.setEmailData || {}
}
const seStatus = state => {
    return state.seStatus || ''
}

const pointInit = state => {
    return state.pointInit || {}
}
const piLoading = state => {
    return state.piLoading || ''
}

const pwdFlag = state => {
    return state.pwdFlag || {}
}
const pfLoading = state => {
    return state.pfLoading || ''
}

const emailFlag = state => {
    return state.emailFlag || {}
}
const efLoading = state => {
    return state.efLoading || ''
}

const pwdData = state => {
    return state.pwdData || {}
}
const psStatus = state => {
    return state.psStatus || ''
}

const cPwdData = state => {
    return state.cPwdData || {}
}
const cpStatus = state => {
    return state.cpStatus || ''
}

const peData = state => {
    return state.peData || {}
}
const peStatus = state => {
    return state.peStatus || ''
}

const checkData = state => {
    return state.checkData || {}
}
const checkStatus = state => {
    return state.checkStatus || ''
}

const cpeData = state => {
    return state.cpeData || {}
}
const cpeLoading = state => {
    return state.cpeLoading || ''
}

const versionData = state => {
    return state.versionData || {}
}
const vLoading = state => {
    return state.vLoading || ''
}

const pcInfoData = state => {
    return state.pcInfoData || {}
}
const pcInfoLoading = state => {
    return state.pcInfoLoading || ''
}

const pccData = state => {
    return state.pccData || {}
}
const pccLoading = state => {
    return state.pccLoading || ''
}

const pcAcData = state => {
    return state.pcAcData || {}
}
const pcAcLoading = state => {
    return state.pcAcLoading || ''
}

const pcPmData = state => {
    return state.pcPmData || {}
}
const pcPmLoading = state => {
    return state.pcPmLoading || ''
}

const pcgData = state => {
    return state.pcgData || {}
}
const pcgLoading = state => {
    return state.pcgLoading || ''
}

const allGearData = state => {
    return state.allGearData || {}
}
const allGearLoading = state => {
    return state.allGearLoading || ''
}

const wRegionData = state => {
    return state.wRegionData || {}
}
const wRegionLoading = state => {
    return state.wRegionLoading || ''
}

const wInfoData = state => {
    return state.wInfoData || {}
}
const wInfoLoading = state => {
    return state.wInfoLoading || ''
}

const wPayModeData = state => {
    return state.wPayModeData || {}
}
const wPayModeLoading = state => {
    return state.wPayModeLoading || ''
}

const wUnloadData = state => {
    return state.wUnloadData || {}
}
const wUnloadLoading = state => {
    return state.wUnloadLoading || ''
}

const wSwitchData = state => {
    return state.wSwitchData || {}
}
const wSwitchLoading = state => {
    return state.wSwitchLoading || ''
}

const wNtloginData = state => {
    return state.wNtloginData || {}
}
const wNtloginLoading = state => {
    return state.wNtloginLoading || ''
}

const wScanloginData = state => {
    return state.wScanloginData || {}
}
const wScanloginLoading = state => {
    return state.wScanloginLoading || ''
}

const wGeneCodeData = state => {
    return state.wGeneCodeData || {}
}
const wGeneCodeLoading = state => {
    return state.wGeneCodeLoading || ''
}

const wGeneInfoData = state => {
    return state.wGeneInfoData || {}
}
const wGeneInfoLoading = state => {
    return state.wGeneInfoLoading || ''
}

const wRoleData = state => {
    return state.wRoleData || {}
}
const wRoleLoading = state => {
    return state.wRoleLoading || ''
}

const wGoodsData = state => {
    return state.wGoodsData || {}
}
const wGoodsLoading = state => {
    return state.wGoodsLoading || ''
}

const wLogoutData = state => {
    return state.wLogoutData || {}
}
const wLogoutLoading = state => {
    return state.wLogoutLoading || ''
}

const codeLogData = state => {
    return state.codeLogData || {}
}
const codeLogLoading = state => {
    return state.codeLogLoading || ''
}

const VKParamsData = state => {
    return state.VKParamsData || {}
}
const VKPLoading = state => {
    return state.VKPLoading || ''
}

const VKCodeLoginData = state => {
    return state.VKCodeLoginData || {}
}
const VKCodeLogLoading = state => {
    return state.VKCodeLogLoading || ''
}
const showPage = state => {
    return state.showPage
}

export default {
    status,
    VKCodeLoginData,
    VKCodeLogLoading,
    VKParamsData,
    VKPLoading,
    codeLogData,
    codeLogLoading,
    wRoleData,
    wRoleLoading,
    wRegionData,
    wRegionLoading,
    wInfoData,
    wInfoLoading,
    wPayModeData,
    wPayModeLoading,
    wUnloadData,
    wUnloadLoading,
    wSwitchData,
    wSwitchLoading,
    wNtloginData,
    wNtloginLoading,
    wScanloginData,
    wScanloginLoading,
    wGeneCodeData,
    wGeneCodeLoading,
    wGeneInfoData,
    wGeneInfoLoading,
    wGoodsData,
    wGoodsLoading,
    wLogoutData,
    wLogoutLoading,
    isLogin,
    loading,
    allGearData,
    allGearLoading,
    pcgData,
    pcgLoading,
    pccData,
    pccLoading,
    pcPmData,
    pcPmLoading,
    pcAcData,
    pcAcLoading,
    pcInfoData,
    pcInfoLoading,
    cpeData,
    cpeLoading,
    peData,
    peStatus,
    checkData,
    checkStatus,
    pointData,
    upLoading,
    pointRule,
    urLoading,
    pointSwitch,
    uwLoading,
    codeData,
    codeStatus,
    setEmailData,
    seStatus,
    pointInit,
    piLoading,
    pwdFlag,
    pfLoading,
    emailFlag,
    efLoading,
    pwdData,
    psStatus,
    cPwdData,
    cpStatus,
    subList,
    subLoading,
    cRoleList,
    crLoading,
    dpList,
    dpLoading,
    userInfo,
    curGearInfo,
    cgLoading,
    payModeInfo,
    pmLoading,
    iapInfo,
    iapLoading,
    orderInfo,
    orderLoading,
    orderData,
    orderStatus,
    orderVerifyData,
    ovStatus,
    reqData,
    reqStatus,
    versionData,
    vLoading,
    showPage
}